import { CoachNote, ApiResponse, PaginatedResponse } from '@court-sync/shared';
import { apiGet, apiPost, apiPut, apiDelete } from './apiClient';

/** Default page size for coach notes (must match backend default). */
export const COACH_NOTES_PAGE_SIZE = 10;

export const coachNotesService = {
  async getStudentNotes(
    studentId: string,
    academyId: string,
    includePrivate: boolean = false,
    pagination?: { page?: number; limit?: number }
  ): Promise<PaginatedResponse<CoachNote>> {
    const page = pagination?.page ?? 1;
    const limit = pagination?.limit ?? COACH_NOTES_PAGE_SIZE;
    return apiGet<CoachNote[]>(`/students/${studentId}/notes`, {
      params: {
        academyId,
        includePrivate: String(includePrivate),
        page,
        limit,
      },
    }) as Promise<PaginatedResponse<CoachNote>>;
  },

  async createNote(
    studentId: string,
    data: {
      academyId: string;
      content: string;
      category: 'general' | 'progress' | 'behavior' | 'goal' | 'parent_communication';
      isPrivate: boolean;
      programId?: string;
      programSkillName?: string;
      rating?: number;
      skillAchieved?: boolean;
    }
  ): Promise<ApiResponse<{ id: string }>> {
    return apiPost<{ id: string }>(`/students/${studentId}/notes`, data);
  },

  async updateNote(
    studentId: string,
    noteId: string,
    data: {
      content?: string;
      category?: 'general' | 'progress' | 'behavior' | 'goal' | 'parent_communication';
      isPrivate?: boolean;
    }
  ): Promise<ApiResponse> {
    return apiPut(`/students/${studentId}/notes/${noteId}`, data);
  },

  async deleteNote(
    studentId: string,
    noteId: string
  ): Promise<ApiResponse> {
    return apiDelete(`/students/${studentId}/notes/${noteId}`);
  },

  async markNoteAsRead(
    studentId: string,
    noteId: string
  ): Promise<ApiResponse> {
    return apiPut(`/students/${studentId}/notes/${noteId}/read`);
  },
};
